import React, { useEffect, useState, useLayoutEffect, useRef } from 'react';
import Modal from '../../components/Modal/modal';
import {
  hv,
  showComp,
  hideComp,
  leftDiv,
  rightDiv,
  eventBtn,
  slideOpen,
  openDrawer,
  closeDrawer
} from './PopupFilter.module.css';
import _ from 'lodash';
import SelectedFiltersForPopUpFilters from './SelectedFilters/SelectedFiltersForPopUpFilters';
import { Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

let filterList = {};
let toastData = {};
const PopupFilter = ({
  handleApply,
  handleToastBlock,
  show,
  setShow,
  dataList = [],
  showFilterComponent = null,
  masterFiltersData = {},
  styleContainer={}
}) => {
  const [selectedFilter, setSelectedFiilter] = useState(
    _.get(dataList, '[0].name')
  );
  const [masterFilters, setMasterFilters] = useState(masterFiltersData || {});
  const [doReset, setDoReset] = useState(false);
  const [showAnimation, setShowAnimation] = useState(false);

  const drawerRef = useRef('');

  const [
    selectedFiltersInHTMLformtodeSelect,
    setSelectedFiltersInHTMLformtodeSelect
  ] = useState({});
  const iconStyles = { width: '15px' };
  const useStyles = makeStyles({
    paperAnchorBottom: {
      borderTopRightRadius: '20px',
      borderTopLeftRadius: '20px',
      maxHeight: '80vh'
    },
    root: {
      ['@media (min-width: 768px)']: {
        display: 'none'
      },
      height: '100vh',
      backgroundColor: '#00000040',
      position: 'fixed'
    }
  });
  const classes = useStyles();

  const CommonTitleText = ({ Img, title, name }) => {
    return (
      <div
        className={`w-11/12 flex px-2 py-4  cursor-pointer rounded ${selectedFilter ==
          name && 'md:bg-skyBlue-200'}`}
        onClick={() => setSelectedFiilter(name)}
      >
        <div className="px-1 ">
          <Img
            className={` fill-current ${
              selectedFilter == name
                ? 'text-skyBlue-300 fill-current'
                : 'text-black-1023'
            } `}
            style={iconStyles}
          />
        </div>
        <div
          className={`px-1 5 text-base ${
            selectedFilter == name ? 'text-skyBlue-300' : 'text-black-1015'
          }`}
        >
          {title}
        </div>
      </div>
    );
  };

  const handleReset = () => {
    setDoReset(true);
    typeof handleApply == 'function' && handleApply({});
    typeof handleToastBlock == 'function' && handleToastBlock({});
  };

  const updateFilters = ({ key, filters }) => {
    setDoReset(false);
    filterList[key] = filters;
    setMasterFilters({
      ...(filterList || {}),
      [key]: filters
    });
  };

  useEffect(() => {
    if (showFilterComponent) setSelectedFiilter(showFilterComponent);
  }, [showFilterComponent]);

  const updateSelectionFields = ({
    key,
    object,
    displayName,
    handleCancel
  }) => {
    toastData[key] = (
      <SelectedFiltersForPopUpFilters
        object={object}
        dispalyName={displayName}
        onCancel={e => {
          handleCancel(e);
        }}
      />
    );
    setSelectedFiltersInHTMLformtodeSelect({
      ...(toastData || {}),
      [key]: toastData[key]
    });
  };

  useEffect(() => {
    if (!show && typeof handleApply == 'function') handleApply(masterFilters);
  }, [masterFilters]);

  useEffect(() => {
    if (!show && typeof handleToastBlock == 'function')
      handleToastBlock(selectedFiltersInHTMLformtodeSelect);
  }, [selectedFiltersInHTMLformtodeSelect]);

  useEffect(() => {
    return () => {
      filterList = {};
      toastData = {};
    };
  }, []);
  const handleAddClass = async () => {
    if (typeof drawerRef?.current?.classList != 'object') return;
    await drawerRef.current.classList.add(openDrawer);
    setTimeout(() => setShowAnimation(true), 100);
  };
  const handleRemoveClass = async () => {
    setShowAnimation(false);

    if (typeof drawerRef?.current?.classList != 'object') return;
    await drawerRef.current.classList.remove(openDrawer);
  };
  useEffect(() => {
    if (show) setTimeout(handleAddClass, 50);
    else setTimeout(handleRemoveClass, 50);
  }, [show]);

  const CustomDisplay = props => (
    <div className="w-full">
      <div className="w-full md:block hidden">
        <Modal
          show={show}
          setShow={setShow}
          title="Filter"
          titleStyle={{
            fontWeight: 'bold',
            fontSize: '20px',
            paddingLeft: '1.5rem'
          }}
          styleContainer={{
            maxWidth: '800px',
            minHeight: '400px',
            maxHeight: '90vh',
            ...(styleContainer||{})
          }}
          modalConentStyle={{ paddingLeft: '0px', paddingRight: '0px' }}
          closeIconStyle={{ paddingRight: '1.5rem' }}
          stopDeafultPropagation={true}
          dontClose={true}
        >
          {props.children}
        </Modal>
      </div>

      <div className={`md:hidden bg-white`}>
        <Drawer
          anchor="bottom"
          open={show}
          onClose={() => {
            setShow(false);
          }}
          classes={{
            paperAnchorBottom: classes.paperAnchorBottom,
            root: classes.root
          }}
        >
          <div
            ref={drawerRef}
            className={`bg-white   ${slideOpen} ${
              showAnimation ? openDrawer : closeDrawer
            }`}
          >
            <div className="flex mx-5">
              <p className="w-full font-semibold my-3 text-lg text-black-1011 mx-1 capitalize ">
                Filter
              </p>
              <CloseIcon
                className="float-right clear-both mr-1 w-14 my-3"
                style={{ color: '#858585' }}
                onClick={() => setShow(false)}
              />
            </div>
            {props.children}
          </div>
        </Drawer>
      </div>
    </div>
  );

  return (
    <div className="popUpFilter">
      <CustomDisplay>
        <hr className="border-navy-900 " />
        <div className="md:flex w-full mt-5 overflow-auto px-6 block">
          <div className={`w-full md:w-5/12 ${leftDiv}`}>
            {dataList?.map(each => (
              <CommonTitleText
                Img={each?.img}
                title={each?.title}
                name={each?.name}
              />
            ))}
          </div>
          <div className={`w-3 hidden md:block`}>
            <div className={hv}></div>
          </div>
          <hr className="md:hidden border-navy-900 mb-5" />

          <div className={`w-full md:px-5 ${rightDiv}`}>
            {dataList?.map(each => {
              return (
                <div
                  className={`bg-grey-950 rounded  md:bg-white md:px-auto md:py-0 px-2 py-5 ${
                    each?.name == selectedFilter ? showComp : hideComp
                  }`}
                >
                  {each?.component({
                    masterFilter: masterFilters,
                    updateFilters: updateFilters,
                    doReset: doReset,
                    updateSelectionFieldsInHTMLFormatForDeSelect: updateSelectionFields,
                    dependencyData: each?.dependencyData || ''
                  })}
                </div>
              );
            })}
          </div>
        </div>
        <div className={`w-full ${eventBtn} mt-14 pt-5 pb-4 px-6 text-right`}>
          <button
            className="bg-red-400 text-white font-roboto font-medium text-sm py-3 px-4 rounded w-32 py-2 "
            type="button"
            onClick={handleReset}
          >
            Reset
          </button>
          <button
            className="bg-green-600 text-white font-roboto font-medium text-sm py-3 px-4 rounded w-32 py-2 ml-4"
            type="button"
            onClick={() => {
              typeof handleApply == 'function' && handleApply(masterFilters);
              typeof handleToastBlock == 'function' &&
                handleToastBlock(selectedFiltersInHTMLformtodeSelect);
              setShow(false);
            }}
          >
            Apply
          </button>
        </div>
      </CustomDisplay>
    </div>
  );
};
export default React.memo(PopupFilter);
